// legal pages
export const AboutUs = 'https://endtherig.com/about-us/'
export const PrivacyPolicy = 'https://endtherig.com/privacy-policy/'
export const CommunityPolicy = 'https://endtherig.com/community-policy/'
export const TermsAndServices = 'https://endtherig.com/terms-and-services/'
export const Launch_Article_Gitbook = 'https://book.endtherig.com/'
export const Wiki_End_The_Rig = 'https://wiki.endtherig.com/'
